import React from 'react';
import { LoadingSpinner } from '../../../atoms/LoadingSpinner';
import { ContentWrapperContext } from '../../../blocks/ContentWrapper/ContentWrapperContext';

type BlockInteractionsLoadingSpinnerType = {
  uuid: string;
  contentWrapperContext?: ContentWrapperContext | null;
};
/**
 * When the block is moved by user interaction or added new block, the process is indicated here.
 */
export function BlockInteractionsLoadingSpinner({ uuid, contentWrapperContext }: BlockInteractionsLoadingSpinnerType) {
  if (contentWrapperContext?.action?.uuid === uuid) {
    return (
      <div className="block-interactions__spinner">
        <LoadingSpinner />
      </div>
    );
  }
  return null;
}
